import axios from 'axios'
import router from "@/router";
import { Message } from 'element-ui'

// 创建可一个新的axios对象
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址
    timeout: 30000
})

// 是否正在刷新token的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = JSON.parse(localStorage.getItem("honey-user") || '{}')
    
    // 检查token是否存在
    if (user.token) {
        config.headers['token'] = user.token  // 设置请求头
    }

    return config
}, error => {
    console.error('request error: ' + error) // for debug
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        
        // 处理token过期的各种情况
        if (res.code === '401' || res.code === 401 || 
            res.msg === 'token过期' || res.msg === 'token无效' || 
            res.msg === '未登录' || res.msg === 'Token已过期' ||
            res.msg === 'Token验证失败' || res.msg === '请重新登录' ||
            res.msg === '账号在其他设备登录，请重新登录') {
            
            // 避免重复处理
            if (!isRefreshing) {
                isRefreshing = true
                
                // 清除本地存储的用户信息
                localStorage.removeItem('honey-user')
                
                // 根据不同的错误消息显示不同的提示
                let warningMsg = '登录已过期，请重新登录'
                if (res.msg === '账号在其他设备登录，请重新登录') {
                    warningMsg = '您的账号已在其他设备登录，请重新登录'
                }
                
                // 显示提示信息
                Message.warning({
                    message: warningMsg,
                    duration: 5000,
                    showClose: true
                })
                
                // 跳转到登录页面
                router.push('/login').finally(() => {
                    isRefreshing = false
                })
            }
            
            return Promise.reject(new Error('Token已过期'))
        }
        
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        
        // 处理网络错误或服务器错误
        if (error.response) {
            const { status, data } = error.response
            
            // 处理401未授权错误
            if (status === 401) {
                if (!isRefreshing) {
                    isRefreshing = true
                    
                    // 清除本地存储的用户信息
                    localStorage.removeItem('honey-user')
                    
                    // 根据错误消息显示不同的提示
                    let warningMsg = '登录已过期，请重新登录'
                    if (data && data.msg === '账号在其他设备登录，请重新登录') {
                        warningMsg = '您的账号已在其他设备登录，请重新登录'
                    }
                    
                    // 显示提示信息
                    Message.warning({
                        message: warningMsg,
                        duration: 5000,
                        showClose: true
                    })
                    
                    // 跳转到登录页面
                    router.push('/login').finally(() => {
                        isRefreshing = false
                    })
                }
                
                return Promise.reject(new Error('未授权访问'))
            }
            
            // 处理403禁止访问错误
            if (status === 403) {
                Message.error('没有权限访问此资源')
                return Promise.reject(new Error('禁止访问'))
            }
            
            // 处理500服务器错误
            if (status >= 500) {
                Message.error('服务器错误，请稍后重试')
                return Promise.reject(new Error('服务器错误'))
            }
        }
        
        // 处理网络连接错误
        if (!error.response) {
            Message.error('网络连接失败，请检查网络')
        }
        
        return Promise.reject(error)
    }
)

export default request